import { css } from '@emotion/css';
import c from 'classnames';

const buttonStyles = css`
  &.Mui-focusVisible {
    box-shadow:
      0px 0px 0px 3px var(--bg-primary),
      0px 0px 0px 5px var(--focus-secondary);
  }

  &:hover {
    .button-text {
      color: var(--text-secondary);
    }
    .MuiButton-startIcon svg {
      fill: var(--icon-secondary);
    }
  }
`;

export const COMMON_BUTTON_STYLE = c(
  buttonStyles,
  'border border-dashed border-border-dark active:bg-bg-primary hover:bg-bg-primary hover:border-link-internal active:border-link-internal rounded-8 justify-start disabled:opacity-50',
);
